<template>
    <div class="container">
        <section class="section">
            <div class="u-mb-3">
                <div class="u-mb-3 u-pb-0-5"></div>
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center flex-gap-16">
                    <div class="d-flex flex-gap-8 align-items-center u-mt-0-5">
                        <div class="h2 font-weight--bold u-mb-0 line-height--h3">Settings</div>
                    </div>
                </div>
            </div>
            <div class="section__content">
                <ul class="nav nav-tabs d-none d-lg-flex justify-content-start nav-tabs" role="tablist">
                    <li class="nav-item">
                        <button @click="$router.push('/settings/profile')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Profile</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/preferences')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Preferences</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/verification')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Verification</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/security')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Security</span></div>
                        </button>
                    </li>
                    <li class="nav-item nav-item--active">
                        <button @click="$router.push('/settings/payment-methods')" class="btn btn--tertiary btn--block nav-link nav-link--active rounded-0 m-auto"
                                type="button" data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="true">
                            <div class="nav-link__tab"><span class="nav-link__label">Payment methods</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/apps')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Apps</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/limits')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Limits</span></div>
                        </button>
                    </li>
                </ul>
                <div class="dropdown d-block d-lg-none tabs-dropdown">
                    <div class="dropdown-toggle d-block w-100 py-1" id="settings-toggle" aria-haspopup="true"
                         aria-expanded="false"><h4 class="m-0">Payment methods</h4></div>
                </div>
                <hr class="d-block d-lg-none mt-0">
                <div class="row">
                    <div class="col-6 col-sm-4 col-md-3 mb-2">
                        <div title="Add new" data-testid="add-payment-method-button"
                             class="card card--hover text-center card--fixed-size justify-content-start mb-0">
                            <div data-testid="any-payment-methodp2p" role="button" tabindex="0"
                                 class="card__primary-action u-bdrs text-center card--fixed-size justify-content-start mb-0">
                                <span class="thumb--sm"><svg viewBox="0 0 24 24"
                                                             class="icon icon--40 text--muted m-auto"><path
                                        fill-rule="evenodd" clip-rule="evenodd"
                                        d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z"></path></svg></span>
                                <h4 class="mb-0 text--sm mt-1 font-weight--regular text--primary">Add new</h4></div>
                        </div>
                    </div>
                </div>
                <div class="empty-section">
                    <div class="empty-section__image">
                        <img src="@/assets/img/empty-section.svg" alt="empty"></div>
                    <p class="text--black">You haven't configured any payment methods.</p></div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "payment-methods",
    }
</script>

<style scoped>

</style>